export interface SeniorityOption {
	id: string;
	title: string;
}

export const SENIORITY_OPTIONS: SeniorityOption[] = [
	{ id: "owner", title: "Owner" },
	{ id: "founder", title: "Founder" },
	{ id: "c-suite", title: "C-Suite" },
	{ id: "partner", title: "Partner" },
	{ id: "vp", title: "VP" },
	{ id: "head", title: "Head" },
	{ id: "director", title: "Director" },
	{ id: "manager", title: "Manager" },
	{ id: "senior", title: "Senior" },
	{ id: "entry", title: "Entry" },
	{ id: "intern", title: "Intern" },
];
